// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { primaryImageStyles } from "@rpsc/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import IconExpandImage from "@rpsc/XDL/Icons/IconExpandImage";
import { hideElementOnPrint, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

const sharedImg = {
    css: css`
        max-height: 508px;
        width: 508px;
        cursor: pointer;
        ${xScreen("lte", "lg")} {
            max-height: 430px;
            width: 430px;
        }
        ${xScreen("lte", "md")} {
            width: auto;
            height: 100%;
            max-height: 358px;
        }
    `,
};

primaryImageStyles.primaryImage = {
    img: sharedImg,
    image: sharedImg,
    centeringWrapper: {
        css: css`
            border-radius: 2px;
            overflow: hidden;
            margin: 0;
            cursor: pointer;
            aspect-ratio: 1 / 1;
            width: 508px;
            ${xScreen("lte", "lg")} {
                width: 430px;
            }
            ${xScreen("lte", "md")} {
                width: auto;
                height: 100%;
            }
        `,
    },
};

primaryImageStyles.magIcon = {
    src: IconExpandImage,
    size: 24,
    color: "primary",
    css: css`
        position: absolute;
        right: 12px;
        bottom: 12px;
        cursor: pointer;
        &:hover {
            opacity: 0.8;
        }
        ${hideElementOnPrint}
    `,
};

primaryImageStyles.fullPrimaryImageModal = {
    sizeVariant: "large",
    mergeCss: true,
    cssOverrides: {
        modalTitle: css`
            &&&& {
                position: absolute;
                right: 13px;
                top: 13px;
                border: none;
                padding: 0;
                margin: 0;
            }
        `,
        modalBody: css`
            padding: 21px;
        `,
    },
};

primaryImageStyles.badgeAreaWrapper = {
    css: css`
        position: relative;

        @media print {
            width: 50%;
        }
    `,
};

primaryImageStyles.fullPrimaryImage = {
    image: {
        css: css`
            img {
                width: auto;
                max-height: 64vh;
            }
        `,
    },
    img: {
        css: css`
            width: auto;
            max-height: 64vh;
        `,
    },
};
